import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import FormControlGroup from '../FormControlGroup';
import FormContext from '../tools/FormContext';
import FormItemGroup from '../FormItemGroup';
import ConfigConsumerProvider from '../ConfigConsumerProvider';
import FormWrapContext from '../tools/FormWrapContext';

function FormWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      others = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("form", _extends({}, others, {
    className: className,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    }
  }), children);
}

FormWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
FormWrapper.defaultProps = {
  children: null,
  className: ''
};
export default function Form(_ref2) {
  var id = _ref2.id,
      children = _ref2.children,
      className = _ref2.className,
      size = _ref2.size,
      bordered = _ref2.bordered,
      alignControlWidth = _ref2.alignControlWidth,
      inline = _ref2.inline,
      separator = _ref2.separator,
      gutter = _ref2.gutter,
      _ref2$itemMargin = _ref2.itemMargin,
      itemMargin = _ref2$itemMargin === void 0 ? gutter : _ref2$itemMargin,
      vertical = _ref2.vertical,
      labelAlign = _ref2.labelAlign,
      formItemClassName = _ref2.formItemClassName;
  return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
    size: size
  }, function (_ref3) {
    var configSize = _ref3.size;
    return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
      context: FormContext,
      bordered: bordered,
      alignControlWidth: alignControlWidth,
      inline: inline,
      separator: separator,
      itemMargin: itemMargin,
      formItemClassName: formItemClassName,
      vertical: vertical
    }, function (_ref4) {
      var configInline = _ref4.inline;
      return /*#__PURE__*/React.createElement(FormItemGroup, null, /*#__PURE__*/React.createElement(FormControlGroup, null, /*#__PURE__*/React.createElement(FormWrapContext.Provider, {
        id: id,
        className: classNames('jmtd-form', {
          'jmtd-form-large': configSize === 'large',
          'jmtd-form-small': configSize === 'small',
          'jmtd-form-mini': configSize === 'mini',
          'jmtd-form-inline': configInline,
          'jmtd-form-label-align-right': labelAlign === 'right' && !configInline
        }, className),
        wrapper: FormWrapper
      }, children)));
    });
  });
}
Form.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  bordered: PropTypes.bool,
  alignControlWidth: PropTypes.bool,
  inline: PropTypes.bool,
  separator: PropTypes.bool,
  itemMargin: PropTypes.number,
  gutter: PropTypes.number,
  formItemClassName: PropTypes.string,
  labelAlign: PropTypes.oneOf(['left', 'right']),
  vertical: PropTypes.bool
};
Form.defaultProps = {
  id: null,
  children: null,
  className: '',
  size: null,
  bordered: null,
  alignControlWidth: null,
  inline: false,
  separator: false,
  itemMargin: undefined,
  // 废弃，使用gutter取代
  gutter: null,
  formItemClassName: null,
  labelAlign: 'right',
  vertical: null
};